import { formatInr } from './formatInr';

// Amount actually charged so far: while an edit's top-up/refund is pending,
// `amount` already holds the new total, so show the pre-edit amount instead.
export const displayAmount = (b) => {
  const amt = Number(b?.amount || 0);
  if (b?.payment_status === 'top_up_pending') return Math.round((amt - Number(b.top_up_amount || 0)) * 100) / 100;
  if (b?.payment_status === 'refund_pending') return Math.round((amt + Number(b.pending_refund_amount || 0)) * 100) / 100;
  return amt;
};

// Short note under the amount, e.g. "New total ₹2277.40 once ₹920.40 is paid".
export const pendingAmountNote = (b) => {
  if (b?.payment_status === 'top_up_pending') return `New total ${formatInr(b.amount)} once ${formatInr(b.top_up_amount)} is paid`;
  if (b?.payment_status === 'refund_pending') return `New total ${formatInr(b.amount)} after ${formatInr(b.pending_refund_amount)} refund`;
  return '';
};
